import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import UebersichtPage from './pages/UebersichtPage';
import EditorPage from './pages/EditorPage';

export default function DruckInitialenApp() {
  const { programmeId } = useParams<{ programmeId: string }>();
  // Programm-App ist unter /programme/:programmeId/* gemountet — Links immer mit diesem Präfix.
  const base = `/programme/${programmeId}`;
  return (
    <div className="p-6 space-y-4">
      <Routes>
        <Route index element={<UebersichtPage base={base} />} />
        <Route path="neu" element={<EditorPage base={base} />} />
        <Route path="auftrag/:id" element={<EditorPage base={base} />} />
        <Route path="*" element={<Navigate to={base} replace />} />
      </Routes>
    </div>
  );
}
